import { render, staticRenderFns } from "./EditAuctionForm.vue?vue&type=template&id=51a66eee&"
import script from "./EditAuctionForm.vue?vue&type=script&lang=js&"
export * from "./EditAuctionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports